import { useController } from 'react-hook-form';

// const CONTENT = {
//   deliveryBlockHeader: 'Delivery',
//   destinationsFieldLabel: 'Destinations',
// };

const DestinationsFormPlaceholder = () => {
  useController({
    // Not used in the form currently as custom isn't supported yet but placeholder until then
    name: 'destinations',
  });

  return null;
};

export const DeliveryContentBlock = () => {
  return (
    <DestinationsFormPlaceholder />
    // <ContentBlock data-test="delivery-content">
    //   <H4>{CONTENT.deliveryBlockHeader}</H4>
    //   <FormField labelText={CONTENT.destinationsFieldLabel} isHorizontalLayout>
    //     <DestinationSelect />
    //   </FormField>
    // </ContentBlock>
  );
};
